module.exports = __webpack_public_path__ + "img/珍银面膜--OK_05.0585fe0d.jpg";